import styled from 'styled-components';

import VehicleList from './component';

export default styled(VehicleList)`
  .vehicle-list {
    &__header {
      background-color: transparent;

      &:after {
        display: none;
      }

      .vehicle-list__header-row {
        background-color: transparent;

        &:hover {
          background-color: transparent;
        }
      }
    }

    &__row {
      color: var(--grey700);
      font-weight: bold;

      &:hover {
        background-color: var(--primary100);
        cursor: pointer;
      }

      &--inactive {
        background-color: var(--grey100);

        .vehicle-list__cell {
          opacity: 0.5;

          &-name,
          &-tag {
            opacity: 1;
          }
        }
      }
    }

    &__type {
      display: flex;
      flex-direction: column;

      span {
        display: flex;
        justify-content: center;
      }
    }

    &__type-text {
      color: var(--grey500);
      display: flex;
      font-family: Roboto Slab;
      font-size: 0.9rem;
      margin-top: 5px;
      justify-content: center;
    }

    &__extras {
      svg {
        margin-right: 1rem;
      }
    }
  }
`;
